import PropTypes from 'prop-types';

const Skeleton = ({ 
  className = '', 
  width = 'w-full', 
  height = 'h-4', 
  rounded = 'rounded',
  animate = true 
}) => {
  return (
    <div
      className={`
        ${width} ${height} ${rounded}
        bg-card
        ${animate ? 'animate-pulse' : ''}
        ${className}
      `}
      aria-hidden="true"
    />
  );
};

// Preset skeleton components for common use cases
export const SkeletonText = ({ lines = 1, className = '' }) => {
  return (
    <div className={`space-y-spacing-2 ${className}`}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          width={i === lines - 1 && lines > 1 ? 'w-3/4' : 'w-full'}
        />
      ))}
    </div>
  );
};

export const SkeletonConversation = () => {
  return (
    <div className="flex items-center gap-spacing-2 p-spacing-2 rounded-lg">
      <div className="flex-1 space-y-spacing-2">
        <Skeleton width="w-3/4" height="h-4" />
        <Skeleton width="w-1/2" height="h-3" />
      </div>
    </div>
  );
};

export const SkeletonMessage = ({ isUser = false }) => {
  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-spacing-4`}>
      <div className={`${isUser ? 'max-w-[691px]' : 'w-full max-w-[691px]'}`}>
        <div className={`rounded-[16px] px-spacing-4 py-spacing-3 ${isUser ? 'bg-bg-message-user' : 'bg-bg-message-ai'}`}>
          <div className="space-y-spacing-2">
            <Skeleton 
              width="w-48" 
              height="h-4" 
              className={isUser ? 'bg-primary/20' : ''}
            />
            <Skeleton 
              width="w-64" 
              height="h-4" 
              className={isUser ? 'bg-primary/20' : ''}
            />
            <Skeleton 
              width="w-32" 
              height="h-4" 
              className={isUser ? 'bg-primary/20' : ''}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export const SkeletonModelOption = () => {
  return (
    <div className="flex items-center gap-spacing-3 p-spacing-2">
      <Skeleton width="w-6" height="h-6" rounded="rounded" />
      <div className="flex-1 space-y-spacing-1">
        <Skeleton width="w-1/2" height="h-4" />
        <Skeleton width="w-3/4" height="h-3" />
      </div>
    </div>
  );
};

Skeleton.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  rounded: PropTypes.string,
  animate: PropTypes.bool,
};

SkeletonText.propTypes = {
  lines: PropTypes.number,
  className: PropTypes.string,
};

SkeletonMessage.propTypes = {
  isUser: PropTypes.bool,
};

export default Skeleton;